export type G5LinkStatus =
  | 'NAO_GERADO'
  | 'AGUARDANDO_PREENCHIMENTO'
  | 'EXPIRADO'
  | 'FORMULARIO_ENVIADO'

export const G5_LINK_STATUS_LABELS: Record<G5LinkStatus, string> = {
  NAO_GERADO: 'Link ainda não gerado',
  AGUARDANDO_PREENCHIMENTO: 'Aguardando preenchimento',
  EXPIRADO: 'Link expirado',
  FORMULARIO_ENVIADO: 'Formulário enviado',
}

export const G5_LINK_STATUS_DESCRIPTIONS: Record<G5LinkStatus, string> = {
  NAO_GERADO: 'O financeiro ainda não gerou o link de cadastro para o profissional.',
  AGUARDANDO_PREENCHIMENTO: 'O link foi gerado e está aguardando o profissional preencher o cadastro.',
  EXPIRADO: 'O link expirou. Solicite ao financeiro a regeneração do link.',
  FORMULARIO_ENVIADO: 'O profissional já enviou o formulário. O financeiro revisa o cadastro neste chamado.',
}

export function g5LinkStatusTone(status: G5LinkStatus) {
  switch (status) {
    case 'FORMULARIO_ENVIADO':
      return 'emerald' as const
    case 'AGUARDANDO_PREENCHIMENTO':
      return 'amber' as const
    case 'EXPIRADO':
      return 'danger' as const
    default:
      return 'muted' as const
  }
}
